export default {
  name: 'marking--inputP',
  apiService: 'shoes',
  apiPath: '/admin/input_p',
};